"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Platform = void 0;
// ALL THE NEW PLATFORMS SHOULD BE ON LOWER CASE
var Platform;
(function (Platform) {
    Platform["app"] = "app";
    Platform["biteninja"] = "biteninja";
    Platform["doordash"] = "doordash";
    Platform["googleFoodOrdering"] = "googleFoodOrdering";
    Platform["grubhub"] = "grubhub";
    Platform["kiosk"] = "kiosk";
    Platform["skip"] = "skip";
    Platform["uber"] = "uber";
    Platform["waitr"] = "waitr";
    Platform["web"] = "web";
})(Platform = exports.Platform || (exports.Platform = {}));
//# sourceMappingURL=platform.js.map